import { IntegrityMonitorRulesGridWebComponent } from './component/IntegrityMonitorRulesGridWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_GRID } from '../../../webcomponents.constants';

export { IntegrityMonitorRulesGridWebComponent };

window.customElements.define(WEB_COMPONENT_INTEGRITY_MONITOR_RULES_GRID, IntegrityMonitorRulesGridWebComponent);
